import PropTypes from 'prop-types'
import React from 'react'
import { Paragraph, DialogOverlay, DialogOverlayActions } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useEvent } from '@fs/zion-frontend-friends'
import { PillButton } from '../buttons'

export default function AreYouSureOverlay({
  instructions,
  onSaveDraftClick,
  onSubmit,
  saveDraftButtonText,
  saveDraftInstructions,
  submitButtonText,
  ...overlay
}) {
  const [t] = useTranslation()
  const onClick = useEvent((onCallback) => {
    onCallback?.()
    overlay.close()
  })
  return (
    <DialogOverlay
      title={t('are-you-sure-overlay.heading', 'Are you sure?')}
      footer={
        <DialogOverlayActions>
          {onSaveDraftClick && (
            <PillButton onClick={() => onClick(onSaveDraftClick)} emphasis="low" linkName="Are You Sure: Draft">
              {saveDraftButtonText || t('save.as.draft', 'Save Draft')}
            </PillButton>
          )}
          {!onSaveDraftClick && (
            <PillButton onClick={() => onClick(overlay.close())} emphasis="low" linkName="Are You Sure: Cancel">
              {t('common-ui:cancel.action', 'Cancel')}
            </PillButton>
          )}
          <PillButton onClick={() => onClick(onSubmit)} data-testid="button-yes-submit" linkName="Are You Sure: Submit">
            {submitButtonText || t('common-ui:submit.action', 'Submit')}
          </PillButton>
        </DialogOverlayActions>
      }
      {...overlay}
    >
      {instructions && <Paragraph size="sm">{instructions}</Paragraph>}
      {onSaveDraftClick && saveDraftInstructions && <Paragraph size="sm">{saveDraftInstructions}</Paragraph>}
    </DialogOverlay>
  )
}

AreYouSureOverlay.propTypes = {
  instructions: PropTypes.string,
  onSaveDraftClick: PropTypes.func,
  onSubmit: PropTypes.func,
  saveDraftButtonText: PropTypes.string,
  saveDraftInstructions: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  submitButtonText: PropTypes.string,
}
